import { useI18n } from "providers/I18nProvider";
import { useGlobalSearchContext } from "../context";
import { EmployeeSearchItem } from "./EmployeeSearchItem";
import { SectionHeader } from "./SectionHeader";

export const Employees = () => {
  const { t } = useI18n();
  const { employees } = useGlobalSearchContext();

  if (employees.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col">
      <SectionHeader title={t("apps.admin.common.employees")} />

      {employees.map((employee) => (
        <EmployeeSearchItem key={employee.id} employee={employee} />
      ))}
    </div>
  );
};
